





























import { Component, Prop, Mixins } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist, PLAYLIST_TYPES } from '@/classes/playlist'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import * as _ from 'lodash'
import { LibraryMixin } from '@/mixins'
import { numberFilter } from '../../../../../filters'

enum CROSS_REFERENCE_ACTIONS {
  ExistInAllPlaylists = 'tracks_exist_all',
  NotExistInAnyPlaylist = 'tracks_not_exist_any'
}

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Mixins(LibraryMixin) {
  @Prop()
  selectedPlaylists: Playlist[]

  referenceAction: CROSS_REFERENCE_ACTIONS = CROSS_REFERENCE_ACTIONS.ExistInAllPlaylists
  name: string = ''

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length === 0) return { message: 'Please select one or more playlists', valid: false }
    if (!this.name) return { message: 'Please enter a playlist name', valid: false }

    return { valid: true }
  }

  async save() {
    if (!this.validation.valid) return

    let trackIds: string[] = []

    if (this.referenceAction === CROSS_REFERENCE_ACTIONS.ExistInAllPlaylists) {
      trackIds = _.intersection(...this.selectedPlaylists.map(x => x.tracks))
    } else if (this.referenceAction === CROSS_REFERENCE_ACTIONS.NotExistInAnyPlaylist) {
      trackIds = _.difference(this.library.tracks.map(x => x._id), ...this.selectedPlaylists.map(x => x.tracks))
    } else {
      throw new Error('unknown cross reference action: ' + this.referenceAction)
    }

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'cross_reference', 'confirm', {
      referenceAction: this.referenceAction
    })

    return Axios.post('/playlist/create', {
      name: this.name,
      type: PLAYLIST_TYPES.Playlist,
      trackIds
    }).then((res) => {
      this.$buefy.notification.open(`Created new playlist with ${numberFilter(trackIds.length)} tracks`)

      return res
    })
  }

  mounted() {
    (this.$refs as any).name.focus()
  }
}
